import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { SupabaseService } from 'src/app/services/supabase.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(
    private readonly supabaseService: SupabaseService,
    private readonly router: Router
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    try {
      await this.supabaseService.waitForInitialization();
      const user = await this.supabaseService.getCurrentUser();
      if (!user) {
        return this.router.createUrlTree(['/login']);
      }

      const role = await this.supabaseService.getUserRole();
      if (role !== 'superadmin' && role !== 'admin' && role !== 'contributor') {
        return this.router.createUrlTree(['/login']);
      }

      return true;
    } catch (error) {
      console.error('Admin guard error:', error);
      return this.router.createUrlTree(['/login']);
    }
  }
}

@Injectable({ providedIn: 'root' })
export class AdminOnlyGuard implements CanActivate {
  constructor(
    private readonly supabaseService: SupabaseService,
    private readonly router: Router
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    try {
      await this.supabaseService.waitForInitialization();
      const role = await this.supabaseService.getUserRole();

      if (role === 'superadmin' || role === 'admin') return true;
      if (role === 'contributor') return this.router.createUrlTree(['/modules-management']);

      return this.router.createUrlTree(['/login']);
    } catch (error) {
      console.error('Admin-only guard error:', error);
      return this.router.createUrlTree(['/login']);
    }
  }
}
